import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormField from 'components/form/form-field-input';
import validateEmail from 'util/misc/validate-email';

class EmailInput extends PureComponent {
    static defaultProps = {};

    static propTypes = {
        messages: PropTypes.object,
        onChange: PropTypes.func,
        tabIndex: PropTypes.number,
        label: PropTypes.string.isRequired,
        value: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            email: this.props.value || '',
        };
    }

    clearEmailInput = () => {
        this.setState({ email: '', isValid: false });

        if (this.props.onChange) {
            this.props.onChange({ email: '', isValid: false });
        }
    };

    handleEmailInput = e => {
        const isValid = validateEmail(e);
        this.setState({ email: e, isValid });

        if (this.props.onChange) {
            this.props.onChange({ email: e, isValid });
        }
    };


    render() {
        const { messages, label, tabIndex } = this.props;
        const { email } = this.state;

        return (
            <FormField
                type="email"
                name="email"
                value={email}
                hasFloatingLabel={true}
                label={label}
                onInput={this.handleEmailInput}
                tabIndex={tabIndex}
                messages={messages}
                hasClearAction={this.clearEmailInput}
            />
        );
    }
}

export default EmailInput;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/email-input/index.js